import React from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import DBABasicInfoComponent from './dba-basic-info.component';
import DBADomainMappings from './dba-domain-mappings';
import DBACategoryMappings from './dba-category-mappings';
import DBACollectionMappings from './dba-collections-mappings';
import DBAOrders from './dba-orders';
import DBABrandMappings from './dba-brand-mapping/containers/brand-mappings';
import DBAMappedWebsitesInfoComponent from './websites/dba-mapped-websites-info.component';

export const DBAComponent = ({ websites, handleFormChange, selectedDba, handleInnerFormChange, accounts, back, handleFormSubmit, dbaId }: any) => {
  const tabItems = [
    {
      id: 0,
      title: `${selectedDba?.Name} - Basic Details`,
      component: <DBABasicInfoComponent
        handleInnerFormChange={handleInnerFormChange}
        selectedDba={selectedDba}
        handleFormChange={handleFormChange}
        accounts={accounts}
      />,
      isVisible: true,
    },
    {
      id: 1,
      title: 'Brand Mappings',
      component: <DBABrandMappings
        selectedDba={selectedDba}
      />,
      isVisible: true,
    },
    {
      id: 2,
      title: 'Domain',
      component: <DBADomainMappings
        selectedDba={selectedDba}
      />,
      isVisible: true,
    },
    {
      id: 3,
      title: 'Category',
      component: <DBACategoryMappings
        selectedDba={selectedDba}
      />,
      isVisible: true,
    },
 
    {
      id: 4,
      title: 'Orders',
      component: <DBAOrders />,
      isVisible: true,
    },
    
    {
      id: 6,
      title: 'Collections',
      component: <DBACollectionMappings
        selectedDba={selectedDba}
      />,
      isVisible: true,
    },
    
    
    {
      id: 7,
      title: 'Mapped Websites Info',
      component: <DBAMappedWebsitesInfoComponent
        selectedDba={selectedDba}
        websites={websites} />,
      isVisible: true,
    },
   
  ];

  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">

      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>

      </div>
    </div>
  );
};

export default DBAComponent;
